module.exports = __webpack_public_path__ + "img/thumbnail-fruit.cbc6f058.jpg";